import { IAction } from "store";
import { DealAction } from "../../actions";
import { MeasureDataTableFilters } from "../../types";
import { reducer } from "../index";
import { defaultMeasureDataTableFilters } from "constants/measure-data";

reducer.createHandler(
  DealAction.SetMonitoringDataFilters,
  (state, { payload }: IAction<Partial<MeasureDataTableFilters> | null>) => ({
    ...state,
    dealModule: {
      ...state.dealModule,
      measureDataTableFilters: payload
        ? { ...state.dealModule.measureDataTableFilters, ...payload }
        : defaultMeasureDataTableFilters
    }
  })
);
